<template>
  <div class="survey">
    <div class="survey-completed-container">
      <h1>Thanks, we are sending your survey</h1>
      <SurveyCompletedIcon />
      <p>Thank you for signing up. Check your email for a message containing your survey link.</p>
    </div>
  </div>
</template>

<script lang="ts">
import SurveyCompletedIcon from '@/app/graphics/SurveyCompletedIcon.vue'
export default {
  components: { SurveyCompletedIcon },
}
</script>
<style lang="sass" scoped>
body, html, .survey
  width: 100%
  height: 100%
body, html, .survey, .survey-completed-container
  overflow-x: hidden !important
.survey-completed-container
  position: absolute
  top: 32px
  width: 100%
  max-width: 512px
  padding: 32px
  svg
    width: 64px
    height: 64px
    margin: 24px auto
    position: relative
  h1, p
    text-align: center
    margin: 0 auto 0
.survey-completed-container, svg
  left: 50%
  transform: translateX(-50%)
</style>
